import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import Cookies from 'js-cookie'

NProgress.configure({ 'showSpinner': false })

router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start()
  if (Cookies.get('token')) {
    // 商家管理员：确保始终带本店 storeId；可进商户页但只能看本店（后端已隔离）
    if (UserModule.isStoreLocked) {
      const info: any = UserModule.userInfo || {}
      try {
        const raw = Cookies.get('user_info')
        const fromCookie = raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : {}
        const sid = info.storeId != null ? info.storeId : fromCookie.storeId
        if (sid != null && !UserModule.storeId) {
          UserModule.SetStore(String(sid))
        }
      } catch (_) {
        /* ignore */
      }
      if (to.path === '/') {
        next('/dashboard')
        NProgress.done()
        return
      }
    }
    // 如果目标路由需要已选择商户，但当前还未选择，则强制跳转到商户管理页
    const requiresStore = to.meta && (to.meta as any).requiresStore
    if (requiresStore && !UserModule.storeId && to.path !== '/store') {
      next('/store')
      NProgress.done()
      return
    }
    const perm = to.meta && (to.meta as any).permission
    if (perm && !UserModule.hasPermission(perm)) {
      Message.warning('无权限访问该页面')
      // 避免无 store:list 时反复跳 /store 形成死循环（表现为「登录进不去」）
      const fallback = UserModule.storeId ? '/dashboard' : '/store'
      if (to.path === fallback || to.path === '/store' || to.path === '/dashboard') {
        NProgress.done()
        next(false)
        return
      }
      next(fallback)
      NProgress.done()
      return
    }
    next()
  } else {
    if (!to.meta.notNeedAuth) {
      next('/login')
    } else {
      next()
    }
  }
})

router.afterEach((to: Route) => {
  NProgress.done()
  document.title = to.meta.title
})
